<div class="alertas">

  <ng-container *ngFor="let alert of alerta">
    <div class="alertaComponent {{alert.Clase}} animated {{alert.Animacion}}">

      <div class="alertaGrupo">

        <div class="icono">
          <span style="font-size: 24px" class="{{alert.Icono}}"></span>
        </div>

        <div class="descripcion">
          <span> {{alert.Descripcion}}</span>
        </div>

        <div class="icono">
          <button type="button" class="close"  aria-label="Close"  (click)="RemoveAlerta(alert)">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>

    </div>
  </ng-container>

</div>
